import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("fl_token");
export const setToken = (t) => localStorage.setItem("fl_token", t);
export const clearToken = () => localStorage.removeItem("fl_token");

export const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (path) => `${BASE}/files/${path}?auth=${encodeURIComponent(getToken() || "")}`;

export async function downloadFile(path, filename) {
  const res = await fetch(fileUrl(path));
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "fruitlove.mp4";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function apiErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
}

export { BASE };
